export default "__VITE_ASSET__BTOzx$mf__"